import * as React from 'react';
import { requestStardogVoiceboxGenesis } from 'vet-bones/utils/voicebox';

import { useDefaultPortalConnection } from 'src/utils/hooks/useDefaultPortalConnection';
import {
  GenerateConceptsRequest,
  GenerateConceptsResponse,
} from 'src/utils/voicebox/hooks/types';

export const useGenerateConcepts = () => {
  const defaultConnection = useDefaultPortalConnection();

  return React.useCallback(
    async (
      project: string,
      description: string,
      questions: Array<{ id: string; question: string }>
    ): Promise<string[] | null> => {
      if (!defaultConnection) {
        return null;
      }

      try {
        const response = await requestStardogVoiceboxGenesis<
          GenerateConceptsRequest,
          GenerateConceptsResponse
        >({
          connectionIdx: defaultConnection.index,
          body: {
            endpoint: defaultConnection.endpoint,
            action: 'generate_concepts',
            parameters: {
              project,
              description: description || '',
              questions,
            },
          },
        });

        if (response.error) {
          throw new Error(response.error);
        }

        return response.results?.concepts || null;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to generate concepts:', err);
        return null;
      }
    },
    [defaultConnection]
  );
};
